import styled from "styled-components";

import { Button } from "_/components/button/styled";

export const Container = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1rem;

  & ${Button} {
    padding: 0;

    &:enabled {
      outline: 0;
    }
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
